module.exports = __webpack_public_path__ + "static/07-thumb-85776d809d783d305057d78da2b24e96.jpg";